<div class="signature-confirm-container">
  <div class="signature-confirm-card">
    <div class="signature-confirm-icon">
      <i class="bi bi-check-circle-fill"></i>
    </div>
    <h2 class="signature-confirm-title">Signature confirmée</h2>
    <p class="signature-confirm-message">
      Votre signature de la lettre de mission a bien été prise en compte.<br />
      Notre équipe vous contactera prochainement pour la suite.
    </p>
    <a class="signature-confirm-link" (click)="goToLogin()">
      Retour à l'accueil
    </a>
  </div>
</div>
